import { type ModuleConfig } from '/@/cool';

export default (): ModuleConfig => {
	return {};
};
